/**
 * Web/PWA aynı-origin çerezde kalır. Paketlenmiş Capacitor build'inde
 * `VITE_API_BASE_URL` verilir; API uzak sunucudan bearer token ile çağrılır.
 */
const configuredBase = (import.meta.env.VITE_API_BASE_URL ?? '').trim().replace(/\/+$/, '');

export const API_BASE_URL = configuredBase;
export const usesBearerAuth = API_BASE_URL.length > 0;

/**
 * Uygulamanın dış dünyadaki origin'i. Web/PWA'da sayfanın kendi origin'i,
 * paketlenmiş istemcide API sunucusunun origin'idir. App Link ve güncelleme
 * indirme URL'leri buna göre doğrulanır.
 */
export function apiOrigin(base: string = API_BASE_URL): string {
  if (base.length === 0) {
    return typeof window === 'undefined' ? '' : window.location.origin;
  }
  try {
    return new URL(base).origin;
  } catch {
    return '';
  }
}

/** API yolu veya API'den gelen göreli URL'yi doğru origin'e taşır. */
export function apiUrl(path: string, base: string = API_BASE_URL): string {
  if (/^https?:\/\//i.test(path)) return path;
  if (base.length === 0) return path.startsWith('/') ? path : `/${path}`;
  if (!path.startsWith('/')) return `${base}/${path}`;
  return `${base}${path}`;
}

/**
 * `<img>`, `<video>` ve `<track>` istekleri için medya yolu yardımcıları
 * ADR-012 Faz 4b'de kaldırıldı. Sunucu tüm medya URL'lerini imzalar.
 */

/** API JSON'undaki `/api/...` yollarını paketlenmiş origin için mutlaklaştırır. */
export function absolutizeApiUrls<T>(value: T, base: string = API_BASE_URL): T {
  if (base.length === 0) return value;
  if (typeof value === 'string') {
    return (value.startsWith('/api/') ? apiUrl(value, base) : value) as T;
  }
  if (Array.isArray(value)) {
    return value.map((entry) => absolutizeApiUrls(entry, base)) as T;
  }
  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, entry] of Object.entries(value)) {
      result[key] = absolutizeApiUrls(entry, base);
    }
    return result as T;
  }
  return value;
}
